import apiFetch from '@wordpress/api-fetch';

/**
 * =========================
 * Field Group APIs
 * =========================
 */
export const fetchGroups = (displayIn = '') => {
    const path = displayIn
        ? `/voxycure/v1/groups?type=${displayIn}`
        : '/voxycure/v1/groups';
    return apiFetch({ path });
};

export const fetchGroup = (id) => {
    if (!id) {
        return Promise.reject(new Error('Field group ID is required'));
    }
    return apiFetch({ path: `/voxycure/v1/group/${id}` });
};

export const saveGroup = (groupData) => {
    const method = groupData.id ? 'PUT' : 'POST';
    const path = groupData.id
        ? `/voxycure/v1/group/${groupData.id}`
        : '/voxycure/v1/groups';
    return apiFetch({ path, method, data: groupData });
};

export const deleteGroup = (id) => {
    return apiFetch({
        path: `/voxycure/v1/group/${id}`,
        method: 'DELETE',
    });
};

/**
 * =========================
 * Post Type APIs
 * =========================
 */
export const fetchPostTypes = (status = '') => {
    const path = status
        ? `/voxycure/v1/post-types?status=${status}`
        : '/voxycure/v1/post-types';
    return apiFetch({ path });
};

export const fetchPostType = (id) => {
    if (!id) {
        return Promise.reject(new Error('Post type ID is required'));
    }
    return apiFetch({ path: `/voxycure/v1/post-type/${id}` });
};

export const savePostType = (postTypeData) => {
    const method = postTypeData.id ? 'PUT' : 'POST';
    const path = postTypeData.id
        ? `/voxycure/v1/post-type/${postTypeData.id}`
        : '/voxycure/v1/post-types';
    return apiFetch({ path, method, data: postTypeData });
};

export const deletePostType = (id) => {
    return apiFetch({
        path: `/voxycure/v1/post-type/${id}`,
        method: 'DELETE',
    });
};

/**
 * =========================
 * Taxonomy APIs
 * =========================
 */
export const fetchTaxonomies = (status = '') => {
    const path = status
        ? `/voxycure/v1/taxonomies?status=${status}`
        : '/voxycure/v1/taxonomies';
    return apiFetch({ path });
};

export const fetchTaxonomy = (id) => {
    if (!id) {
        return Promise.reject(new Error('Taxonomy ID is required'));
    }
    return apiFetch({ path: `/voxycure/v1/taxonomy/${id}` });
};

export const saveTaxonomy = (taxonomyData) => {
    const method = taxonomyData.id ? 'PUT' : 'POST';
    const path = taxonomyData.id
        ? `/voxycure/v1/taxonomy/${taxonomyData.id}`
        : '/voxycure/v1/taxonomies';
    return apiFetch({ path, method, data: taxonomyData });
};

export const deleteTaxonomy = (id) => {
    return apiFetch({
        path: `/voxycure/v1/taxonomy/${id}`,
        method: 'DELETE',
    });
};

/**
 * =========================
 * Options Page APIs
 * =========================
 */
export const fetchOptionPages = (status = '') => {
    const path = status
        ? `/voxycure/v1/options-pages?status=${status}`
        : '/voxycure/v1/options-pages';
    return apiFetch({ path });
};

export const fetchOptionPage = (id) => {
    if (!id) {
        return Promise.reject(new Error('Options page ID is required'));
    }
    return apiFetch({ path: `/voxycure/v1/options-page/${id}` });
};

export const saveOptionPage = (optionsPageData) => {
    const method = optionsPageData.id ? 'PUT' : 'POST';
    const path = optionsPageData.id
        ? `/voxycure/v1/options-page/${optionsPageData.id}`
        : '/voxycure/v1/options-pages';
    return apiFetch({ path, method, data: optionsPageData });
};

export const deleteOptionPage = (id) => {
    return apiFetch({
        path: `/voxycure/v1/options-page/${id}`,
        method: 'DELETE',
    });
};

/**
 * =========================
 * fetchOption (General Settings) APIs
 * =========================
 */

export const fetchOption = async (optionKey) => {
    if (!optionKey) throw new Error('Missing option key');

    const json = await apiFetch({
        path: `/voxycure/v1/options?option_key=${encodeURIComponent(optionKey)}`,
        method: 'GET',
    });

    if (!json.success) {
        throw new Error(json.message || 'Failed to load options');
    }

    return json.data;
};

export const saveOptions = async (optionsData) => {
    try {
        const response = await apiFetch({
            path: '/voxycure/v1/options',
            method: 'POST',
            data: optionsData,
            parse: false,
        });

        const body = await response.json();

        return {
            success: true,
            status: response.status,
            body,
        };
    } catch (error) {
        let body = null;

        try {
            body = await error.json?.();
        } catch (_) {
        }

        return {
            success: false,
            status: error?.status || 500,
            body,
        };
    }
};